import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { AnthropicOptionsInterface } from '../../../../app/interfaces/ProviderOptionsInterface';

export interface AnthropicOptionsProps {
  options: AnthropicOptionsInterface;
  onChange: (options: AnthropicOptionsInterface) => void;
}

const AnthropicOptions: React.FunctionComponent<AnthropicOptionsProps> = (props: AnthropicOptionsProps) => {
  const { options, onChange } = props;
  const { t } = useTranslation();

  const handleWebSearchToggle = (checked: boolean) => {
    onChange({
      ...options,
      webSearch: {
        ...(options.webSearch || { maxTries: 3 }),
        active: checked
      }
    });
  };

  const handleMaxTriesChange = (value: number) => {
    onChange({
      ...options,
      webSearch: {
        ...(options.webSearch || { active: true }),
        maxTries: value
      }
    });
  };

  const handleReasoningToggle = (checked: boolean) => {
    onChange({
      ...options,
      reasoning: {
        ...(options.reasoning || { maxTokens: 2000 }),
        active: checked
      }
    });
  };

  const handleReasoningMaxTokensChange = (value: number) => {
    onChange({
      ...options,
      reasoning: {
        ...(options.reasoning || { active: true }),
        maxTokens: value
      }
    });
  };

  const handleToolUseToggle = (checked: boolean) => {
    onChange({
      ...options,
      toolUse: checked
    });
  };

  return (
    <div className="anthropic-options">
      <h4 className="text-lg mb-2">{t('provider_options.anthropic.title')}</h4>
      
      <div className="p-field-checkbox mb-3">
        <Checkbox
          inputId="anthropic-web-search"
          checked={options.webSearch?.active || false}
          onChange={(e) => handleWebSearchToggle(e.checked)}
        />
        <label htmlFor="anthropic-web-search" className="ml-2">
          {t('provider_options.anthropic.web_search')}
        </label>
      </div>

      {options.webSearch?.active && (
        <div className="p-field mb-3 ml-4">
          <label htmlFor="anthropic-max-tries" className="block mb-1">
            {t('provider_options.anthropic.max_tries')}
          </label>
          <InputNumber
            id="anthropic-max-tries"
            value={options.webSearch?.maxTries || 3}
            onChange={(e) => handleMaxTriesChange(e.value)}
            min={1}
            max={10}
            showButtons
            buttonLayout="horizontal"
            decrementButtonClassName="p-button-secondary"
            incrementButtonClassName="p-button-secondary"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            className="w-full"
          />
        </div>
      )}

      <div className="p-field-checkbox mb-3">
        <Checkbox
          inputId="anthropic-reasoning"
          checked={options.reasoning?.active || false}
          onChange={(e) => handleReasoningToggle(e.checked)}
        />
        <label htmlFor="anthropic-reasoning" className="ml-2">
          {t('provider_options.anthropic.reasoning')}
        </label>
      </div>

      {options.reasoning?.active && (
        <div className="p-field mb-3 ml-4">
          <label htmlFor="anthropic-reasoning-max-tokens" className="block mb-1">
            {t('provider_options.anthropic.reasoning_max_tokens')}
          </label>
          <InputNumber
            id="anthropic-reasoning-max-tokens"
            value={options.reasoning?.maxTokens || 2000}
            onChange={(e) => handleReasoningMaxTokensChange(e.value)}
            min={500}
            max={10000}
            step={500}
            showButtons
            buttonLayout="horizontal"
            decrementButtonClassName="p-button-secondary"
            incrementButtonClassName="p-button-secondary"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            className="w-full"
          />
        </div>
      )}

      {/* <div className="p-field-checkbox mb-3">
        <Checkbox
          inputId="anthropic-tool-use"
          checked={options.toolUse || false}
          onChange={(e) => handleToolUseToggle(e.checked)}
        />
        <label htmlFor="anthropic-tool-use" className="ml-2">
          {t('provider_options.anthropic.tool_use')}
        </label>
      </div> */}
    </div>
  );
};

export default AnthropicOptions;